import { SORTING_DIR } from "@/common/models";
import { ITableConfig } from "@/components/table/table.model";

// file name, information type , context , topic , sensitivity , source , details
export const table_config: ITableConfig = {
  columns: [
    {
      name: "",
      key: "menu",
      spanMin: "4rem",
      spanMax: "4rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: true,
    },
    {
      name: "Template Name",
      key: "name",
      spanMin: "20rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
    },
    {
      name: "Created By",
      key: "author",
      spanMin: "15rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
    },
    {
      name: "Created At",
      key: "created_at",
      spanMin: "15rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
    },
    /*  {
      name: "Last Modified By",
      key: "last_modified_by",
      spanMin: "15rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
    }, */
    {
      name: "Last Modified at",
      key: "updated_at",
      spanMin: "15rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
    },
    {
      name: "Access",
      key: "access",
      spanMin: "15rem",
      spanMax: "15rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
    },
    {
      name: "Scheduled",
      key: "scheduled",
      spanMin: "15rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
    },
  ],
};
